/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type GetAdvancedPatientHistoryPrefillQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  type: Types.PatientHistoryType
}>

export type GetAdvancedPatientHistoryPrefillQuery = {
  __typename?: 'Query'
  patientHistoryPrefillData: { __typename?: 'PatientHistoryPrefillData'; value: Types.JSONObject }
}

export const GetAdvancedPatientHistoryPrefillDocument = gql`
  query getAdvancedPatientHistoryPrefill($uid: ID!, $type: PatientHistoryType!) {
    patientHistoryPrefillData(uid: $uid, type: $type) {
      value
    }
  }
`

/**
 * __useGetAdvancedPatientHistoryPrefillQuery__
 *
 * To run a query within a React component, call `useGetAdvancedPatientHistoryPrefillQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedPatientHistoryPrefillQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedPatientHistoryPrefillQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetAdvancedPatientHistoryPrefillQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdvancedPatientHistoryPrefillQuery,
    GetAdvancedPatientHistoryPrefillQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedPatientHistoryPrefillQuery, GetAdvancedPatientHistoryPrefillQueryVariables>(
    GetAdvancedPatientHistoryPrefillDocument,
    options
  )
}
export function useGetAdvancedPatientHistoryPrefillLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdvancedPatientHistoryPrefillQuery,
    GetAdvancedPatientHistoryPrefillQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<GetAdvancedPatientHistoryPrefillQuery, GetAdvancedPatientHistoryPrefillQueryVariables>(
    GetAdvancedPatientHistoryPrefillDocument,
    options
  )
}
export type GetAdvancedPatientHistoryPrefillQueryHookResult = ReturnType<
  typeof useGetAdvancedPatientHistoryPrefillQuery
>
export type GetAdvancedPatientHistoryPrefillLazyQueryHookResult = ReturnType<
  typeof useGetAdvancedPatientHistoryPrefillLazyQuery
>
export type GetAdvancedPatientHistoryPrefillQueryResult = Apollo.QueryResult<
  GetAdvancedPatientHistoryPrefillQuery,
  GetAdvancedPatientHistoryPrefillQueryVariables
>
